module.exports = __webpack_public_path__ + "img/partner_img21.0e2d5d90.png";